/* Notifications: the bell's count, kept fresh while the app is open. */
import { create } from 'zustand'
import { useEffect } from 'react'
import { call, supa, backendReady } from './supa'
import { useMe } from './session'

export interface Note { id: number; kind: string; data: Record<string, unknown>; read_at: string | null; created_at: string }

export const useNotes = create<{ list: Note[]; loaded: boolean }>(() => ({ list: [], loaded: false }))

let sub: ReturnType<typeof supa.channel> | null = null
let subFor: string | null = null

export async function loadNotes() {
  if (!backendReady || !useMe.getState().me) return
  try {
    const list = await call<Note[]>('my_notifications', { p_limit: 60 })
    useNotes.setState({ list, loaded: true })
  } catch { /* keep what we had */ }
}

export async function markNotesRead() {
  const list = useNotes.getState().list
  if (!list.some((n) => !n.read_at)) return
  useNotes.setState({ list: list.map((n) => ({ ...n, read_at: n.read_at || new Date().toISOString() })) })
  try { await call('read_notifications') } catch { /* fine */ }
}

/* New notifications arrive live: the table is watched for rows addressed to you. */
function watch(uid: string | null) {
  if (subFor === uid) return
  if (sub) { void supa.removeChannel(sub); sub = null }
  subFor = uid
  if (!uid || !backendReady) return
  sub = supa.channel('notes:' + uid).on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'notifications', filter: `user_id=eq.${uid}` }, (p) => {
    const n = p.new as Note
    useNotes.setState((s) => ({ list: [n, ...s.list.filter((x) => x.id !== n.id)] }))
  }).subscribe()
}

export function useUnread() {
  const me = useMe((s) => s.me)
  const list = useNotes((s) => s.list)
  useEffect(() => {
    watch(me?.id || null)
    if (me) void loadNotes()
    else useNotes.setState({ list: [], loaded: false })
  }, [me?.id])
  return list.filter((n) => !n.read_at).length
}
